import React from "react";
var __jsx = React.createElement;
import TamaraForm from "@/pages/checkout/bnpl/tamara/components/TamaraForm";
var TamaraFormPage = function TamaraFormPage() {
  return /*#__PURE__*/React.createElement(TamaraForm, null);
};
export default TamaraFormPage;